import { Inject, ModelEvents, GameRandom, Singleton, List } from "../../modules/@denishussar/html5-game-engine";
import CommonRuleConstants from "../Constants/CommonRuleConstants";
import { PromocodeTypeConstants } from "../Constants/PromocodeTypeConstants";
import { Point } from "../Utils/Point";
import { BgCollisionContainerModel } from "./BgCollisionContainerModel";
import { BgBackCityTileContainerModel } from "./BgContainerModels/BgBackCityTileContainerModel";
import { BgCloudTileContainerModel } from "./BgContainerModels/BgCloudTileContainerModel";
import { BgFenceTileContainerModel } from "./BgContainerModels/BgFenceTileContainerModel";
import { BgFloorTileContainerModel } from "./BgContainerModels/BgFloorTileContainerModel";
import { BgMainCityTileContainerModel } from "./BgContainerModels/BgMainCityTileContainerModel";
import { PlayerModel } from "./PlayerModel";

export interface IPromocodesListModel {
    promocode: string,
    type: PromocodeTypeConstants
}
export interface ILeaderBoardListModel {
    id: string,
    name: string,
    score: number,
}
export enum GameModalsEnum {
    none,
    pause,
    record,
    settings,
    exitGame,
    exitMenu,
    outfit,
    gameover,
    error,
    prizes,
    my_prize,
    promocodes,
    promocodes_list,
    leader_board,
    loader,
    tutor,
    tapToStart,
    enterName,
    choosePerson,
    tutorial,
}

@Singleton
export class GameModel {
    public gameOver: boolean = true;
    public showTutorial: boolean = false;
    public showGame: boolean = false;
    public showSpinner: boolean = false;
    public copiedStatus: boolean = false;
    public cameraPos: Point = new Point(0, -170);
    public cameraZoom: number = 0.66;
    public bgContainer = new BgFloorTileContainerModel();
    public cloudContainer = new BgCloudTileContainerModel();
    public backCityContainer = new BgBackCityTileContainerModel();
    public mainCityContainer = new BgMainCityTileContainerModel();
    public fenceContainer = new BgFenceTileContainerModel();
    public bgCollisionContainer = new BgCollisionContainerModel();
    public distance = 0;
    public tapToStart = true;
    public player = new PlayerModel();
    public playerGender = 'woman';
    public pause: boolean = false;
    public leaderBoard: boolean = false;
    public prizes: boolean = false;
    public showPopupShading: boolean = false;
    public outfitAmount: number = 0;
    public levelSpeed: number = 1.5;
    public showMainMenu: boolean = true;
    public startNewGame: boolean = false;
    public exitGame: boolean = false;
    public showMainMenuContainer: boolean = false;
    public modalState: GameModalsEnum = GameModalsEnum.none;
    public isMusicOn = true;
    public tutorialWasShow = false;
    public isSoundsOn = true;
    public outfitView: number = 0;
    public errorMessage: string = "Network error";
    public promocode: string = "XYZAS1";
    public distanceToGenerateOutfit = CommonRuleConstants.DistanceToGenerateOutfit;
    public distanceToGenerateBonus = CommonRuleConstants.DistanceToGenerateBonus;
    public distanceToGenerateStopper = CommonRuleConstants.DistanceToGenerateStopper;
    public bonusCount = 0;
    public totalBonusCount = 0;
    public collectAchievements: number[] = [0, 0, 0, 0, 0, 0, 0, 0];
    public actualPrize: PromocodeTypeConstants = null;
    public promocodeList: IPromocodesListModel[] = [];
    public leaderboard: ILeaderBoardListModel[] = [
        { id: '0', name: "TEST_NAME_1", score: 5203 },
        { id: '1', name: "TEST_NAME_2", score: 5303 },
        { id: '2', name: "TEST_NAME_3", score: 1234 },
        { id: '3', name: "TEST_NAME_4", score: 3456 },
        { id: '4', name: "TEST_NAME_5", score: 4563 },
        { id: '5', name: "TEST_NAME_6", score: 2456 },
        { id: '6', name: "TEST_NAME_7", score: 4567 },
        { id: '7', name: "TEST_NAME_8", score: 6756 },
        { id: '8', name: "TEST_NAME_9", score: 9087 },
        { id: '9', name: "TEST_NAME_10", score: 6785 },
    ];
    public playerName: string;
    public userProfile: any = {
        coinsCount: 0,
        highScore: 0,
        name: '',
        outfit: [
            { outfitid: 1, status: 1 },
            { outfitid: 2, status: 0 },
            { outfitid: 3, status: 0 },
            { outfitid: 4, status: 0 },
            { outfitid: 5, status: 0 },
        ],
        prizeRaffleCount: 0,
        userToken: ''
    };

    constructor(@Inject private _$random: GameRandom,
        @Inject private _$modelEvents: ModelEvents) {
    }

    public endGame() {
        this.gameOver = true;
    }
}

